/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {ObjectService} from "../services/object.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {ObjectCategory} from "../models/object-category";
import {PAGING_ITEMS_PER_PAGE} from "../app-constants";
import { PagedResults } from "app/models/paged-results";
import { ObjectDefinition } from "app/models/object-definition";

@Injectable()
//@Input() KHT - using the @Input() tag breaks certain resolvers after Angular 12 update
export class PeoplePagingResolver implements Resolve<PagedResults<ObjectDefinition>> {

  constructor(
    private mObjectService: ObjectService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<PagedResults<ObjectDefinition>> {
    try {
      return await this.mObjectService.getAllObjectsForCategoryPaging(ObjectCategory.PEOPLE, 0, PAGING_ITEMS_PER_PAGE, 'ASC', "")
    } catch (error) {
      console.error("Problem resolving People Types... Error: " + error, error);
    }
  }

}
